module.exports = __webpack_public_path__ + "js/components/images/zap_logo_loyalty_white-e15050430cfa215743c6879017ab7189.svg";


//////////////////
// WEBPACK FOOTER
// ./js/components/images/zap_logo_loyalty_white.svg
// module id = 827
// module chunks = 31